//
//  CsvExportButtonList.tsx
//
//  isana.net,inc. Proprietary and Confidential
//

import React from "react";
import { CsvExportButton } from "./CsvExportButton";
import { CsvType, csvTypes } from "../constants/csv";
import { Box, Typography } from "@mui/material";
import { CsvExportCommonProps } from "../hooks/useCsvExportButton";

type CsvExportButtonListProps = CsvExportCommonProps & {
  disabled: boolean;
};

export const CsvExportButtonList: React.FC<CsvExportButtonListProps> = ({
  startDate,
  endDate,
  showMessage,
  disabled = false,
}) => {
  const filteredTypes = csvTypes.filter((csv) => csv.type !== "summary");
  return (
    <Box display="flex" gap={2} alignItems="flex-start">
      <Box>
        {filteredTypes.map((csv) => (
          <Box
            key={csv.type}
            display="flex"
            alignItems="center"
            gap={2}
            mb={1.2}
            justifyContent="space-between"
          >
            <CsvExportButton
              csvType={csv.type as CsvType} 
              startDate={startDate}
              endDate={endDate}
              showMessage={showMessage}
              disabled={disabled}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};
